import { ConversationPlatform } from "@redotech/redo-model/conversation";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const metricsSchema = z.object({
  numConversations: z.number(),
  resolutionRevenue: z.number(),
  numResolved: z.number(),
  resolutionRate: z.number(),
  numEscalated: z.number(),
  escalationRate: z.number(),
  totalOrdersProduced: z.number(),
});

export type SupportAgentMetrics = z.infer<typeof metricsSchema>;
export type SupportAgentDailyMetrics = SupportAgentMetrics & { date: string };

export const getSupportAgentSplitAnalytics = {
  name: "getSupportAgentSplitAnalytics" as const,
  input: z.object({
    splitName: z.string(),
    teamIds: z.array(zExt.objectId()).optional(),
    platforms: z.array(z.nativeEnum(ConversationPlatform)).optional(),
  }),
  output: z.object({
    splitName: z.string(),
    treatments: z.array(
      z.object({
        name: z.string(),
        aggregateMetrics: metricsSchema,
        dailyMetrics: z.array(
          metricsSchema.extend({
            date: z.string(), // YYYY-MM-DD
          }),
        ),
      }),
    ),
    allTeams: z.array(
      z.object({
        id: zExt.objectId(),
        name: z.string(),
        isActive: z.boolean(),
      }),
    ),
  }),
};
